import { render, staticRenderFns } from "./summaryTable.vue?vue&type=template&id=609bc27d&"
import script from "./summaryTable.vue?vue&type=script&lang=ts&"
export * from "./summaryTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports